<account-verify [userTitle]="strings.CreateYourCombinumAccount"
                [userDescription]="strings.VerificationCodeRequestSignUpDescription"
                isNew="true"
                [validateEmail]="true"
                [userInputTitle]="strings.EmailAddress"
                [errorMessage]="message"
                (userSubmit)="onUserSubmit($event)"
                (codeSubmit)="onCodeSubmit($event)"></account-verify>